import React from 'react';

import Container from '@components/Container';

import classes from './styles';

const PrivacyPolicy = () => (
  <Container>
    <div className={classes.container}>
      <h2 className={classes.heading}>Privacy Policy</h2>
      <div>
        <p>
          The use of this web site constitutes agreement with the following terms and conditions:

        </p>
        <p>
          (a) The United Nations maintains this web site (the &ldquo;Site&rdquo;)
          as a courtesy to those who may choose to access the Site (&ldquo;Users&rdquo;).
          The information presented herein is for informative purposes only. The United
          Nations grants permission to Users to visit the Site and to download and copy
          the information, documents and materials (collectively, &ldquo;Materials&rdquo;)
          from the Site for the User&rsquo;s personal, non-commercial use, without any right
          to resell or redistribute them or to compile or create derivative works therefrom,
          subject to the terms and conditions outlined below, and also subject to more
          specific restrictions that may apply to specific Material within this Site.
        </p>
        <p>
          (b) The United Nations administers this Site. All Material on this Site from the United
          Nations appears subject to the present Terms and Conditions.
        </p>
        <p>
          (c) Unless expressly stated otherwise, the findings, interpretations and conclusions
          expressed in the Materials on this Site are those of the various United Nations staff
          members, consultants and advisers to the United Nations Secretariat who prepared the
          work and do not necessarily represent the views of the United Nations or its Member
          States.
        </p>
        <p>&nbsp;</p>
        <h3><b>Disclaimers</b></h3>
        <p>
          Materials provided on this Site are provided &ldquo;as is&rdquo;, without warranty of
          any kind, either express or implied, including, without limitation, warranties of
          merchantability, fitness for a particular purpose and non-infringement. The United
          Nations specifically does not make any warranties or representations as to the accuracy
          or completeness of any such Materials. The United Nations periodically adds, changes,
          improves or updates the Materials on this Site without notice. Under no circumstances
          shall the United Nations be liable for any loss, damage, liability or expense incurred
          or suffered that is claimed to have resulted from the use of this Site, including, without
          limitation, any fault, error, omission, interruption or delay with respect thereto. The
          use of this Site is at the User&rsquo;s sole risk. Under no circumstances, including but
          not limited to negligence, shall the United Nations or its affiliates be liable for
          any direct, indirect, incidental, special or consequential damages, even if the United
          Nations has been advised of the possibility of such damages.
        </p>
        <p>
          The User specifically acknowledges and agrees that the United Nations is not liable
          for any conduct of any User.
        </p>
        <p>
          This site may contain advice, opinions and statements of various information providers.
          The United Nations does not represent or endorse the accuracy or reliability of any
          advice, opinion, statement or other information provided by any information provider,
          any User of this Site or any other person or entity. Reliance upon any such advice,
          opinion, statement, or other information shall also be at the User&rsquo;s own risk.
          Neither the United Nations nor its affiliates, nor any of their respective agents,
          employees, information providers or content providers, shall be liable to any User
          or anyone else for any inaccuracy, error, omission, interruption, deletion, defect,
          alteration of or use of any content herein, or for its timeliness or completeness,
          nor shall they be liable for any failure of performance, computer virus or communication
          line failure, regardless of cause, or for any damages resulting therefrom.
        </p>
        <p>
          As a condition of use of this Site, the User agrees to indemnify the United Nations
          and its affiliates from and against any and all actions, claims, losses, damages,
          liabilities and expenses (including reasonable attorneys&rsquo; fees) arising out
          of the User&rsquo;s use of this Site, including, without limitation, any claims
          alleging facts that if true would constitute a breach by the User of these Terms
          and Conditions. If the User is dissatisfied with any Material on this Site or
          with any of its Terms and Conditions of Use, the User&rsquo;s sole and exclusive
          remedy is to discontinue using the Site.
        </p>
        <p>
          This Site may contain links and references to third-party web sites. The linked sites
          are not under the control of the United Nations, and the United Nations is not
          responsible for the content of any linked site or any link contained in a linked
          site. The United Nations provides these links only as a convenience, and the
          inclusion of a link or reference does not imply the endorsement of the linked
          site by the United Nations.
        </p>
        <p>
          If this Site contains bulletin boards, chat rooms, access to mailing lists or other
          message or communication facilities (collectively, &ldquo;Forums&rdquo;), the User
          agrees to use the Forums only to send and receive messages and materials that are
          proper and related to the particular Forum. By way of example and not as a limitation,
          the User agrees that when using a Forum, he or she shall not do any of the following:
        </p>
        <p>
          (a) Defame, abuse, harass, stalk, threaten or otherwise violate the legal rights
          (such as rights of privacy and publicity) of others;
        </p>
        <p>
          (b) Publish, post, distribute or disseminate any defamatory, infringing, obscene,
          indecent or unlawful material or information;
        </p>
        <p>
          (c) Upload or attach files that contain software or other material protected by
          intellectual property laws (or by rights of privacy and publicity) unless
          the User owns or controls the rights thereto or has received all consents
          therefore as may be required by law;
        </p>
        <p>
          (d) Upload or attach files that contain viruses, corrupted files or any other
          similar software or programs that may damage the operation of another&rsquo;s computer;
        </p>
        <p>
          (e) Delete any author attributions, legal notices or proprietary designations or
          labels in any file that is uploaded;
        </p>
        <p>
          (f) Falsify the origin or source of software or other material contained
          in a file that is uploaded;
        </p>
        <p>
          (g) Advertise or offer to sell any goods or services, or conduct or forward surveys,
          contests or chain letters, or download any file posted by another user of a Forum
          that the User knows, or reasonably should know, cannot be legally distributed
          in such manner.
        </p>
        <p>
          The User acknowledges that all Forums and discussion groups are public and not private
          communications. Further, the User acknowledges that chats, postings, conferences,
          e-mails and other communications by other Users are not endorsed by the United Nations,
          and that such communications shall not be considered to have been reviewed, screened
          or approved by the United Nations. The United Nations reserves the right to remove,
          for any reason and without notice, any content of the Forums received from Users,
          including, without limitation, e-mail and bulletin board postings.
        </p>
        <p>
          The boundaries and names shown and the designations used on the maps on this site
          do not imply official endorsement or acceptance by the United Nations.
        </p>
        <p>&nbsp;</p>
        <h3><b>Country and area nomenclature</b></h3>
        <p>
          The designations employed and the presentation of material in this website do
          not imply the expression of any opinion whatsoever on the part of the Secretariat
          of the United Nations concerning the legal status of any country, territory,
          city or area or of its authorities, or concerning the delimitation of its
          frontiers or boundaries. The term &ldquo;country&rdquo; as used in this material
          also refers, as appropriate, to territories or areas.
        </p>
        <p>&nbsp;</p>
        <h3><b>Privacy notice</b></h3>
        <p>
          By accessing this site, certain information about the User, such as Internet
          protocol (IP) addresses, navigation through the Site, the software used and
          the time spent, along with other similar information, will be stored on United
          Nations servers. These will not specifically identify the User. The information
          will be used internally only for web site traffic analysis. If the User provides
          unique identifying information, such as name, address and other information on
          forms stored on this Site, such information will be used only for statistical
          purposes and will not be published for general access. The United Nations,
          however, assumes no responsibility for the security of this information.
        </p>
        <p>&nbsp;</p>
        <h3><b>Preservation of immunities</b></h3>
        <p>
          Nothing herein shall constitute or be considered to be a limitation upon or a waiver
          of the privileges and immunities of the United Nations, which are specifically reserved.
        </p>
        <p>&nbsp;</p>
        <h3><b>General</b></h3>
        <p>
          The United Nations reserves its exclusive right in its sole discretion to alter,
          limit or discontinue the Site or any Materials in any respect. The United Nations
          shall have no obligation to take the needs of any User into consideration in
          connection therewith.
        </p>
        <p>
          The United Nations reserves the right to deny in its sole discretion any user
          access to this Site or any portion thereof without notice.
        </p>
        <p>
          No waiver by the United Nations of any provision of these Terms and Conditions
          shall be binding except as set forth in writing and signed by its duly authorized
          representative.
        </p>
      </div>
    </div>
  </Container>
);

export default PrivacyPolicy;
